module.exports = __webpack_public_path__ + "images/blog/blog_card/no_image_ctoc_b42a00c371432d58c91a84fe9f12d033.png";